/*
 * @FilePath     : /es-package/packages/es-mpx-usex/lib/relog.js
 * @Author       : LiYang
 * @Date         : 2022-01-15 15:23:45
 * @LastEditTime: 2023-03-22 11:35:09
 * @LastEditors: showangjing showangjing@didiglobal.com
 * @Description  :
 */

import store from './store'

export default (callback) => {
    return store.dispatch('getToken',true).then(callback || ((res) => res))
}
